import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import {ReservationService} from '@app/_components/reservation';

@Component({
    selector: 'app-interim-cleaning',
    templateUrl: './interim-cleaning.component.html',
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class InterimCleaningComponent implements OnInit {
  @Input() housekeepingReport: any;
	  constructor(

    private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) {
		// 	this.showFilter = data?.showFilter;
		// this.showPagination = data?.showPagination;
	}
	ngOnInit(): void {

	}


}
